import { useState, ChangeEvent, FormEvent, useCallback } from "react";
import styles from "./ResetPassword.module.css";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "initialize";
import ProcessingButtonBase from "components/Btn/BtnWithProcessing/ProcessingButtonBase";
import { ReactComponent as IconLogo } from "components/TopHeader/IconLogo.svg";
import { Link } from "react-router-dom";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleEmailChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setEmail(event.target.value);
    },
    []
  );

  const [isProcessing, setIsProcessing] = useState(false);
  const [sentTo, setSentTo] = useState("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    setIsProcessing(true);
    sendPasswordResetEmail(auth, email)
      .then(() => {
        setSentTo(email);
      })
      .catch((error) => {
        if (error.code === "auth/invalid-email") {
          setErrorMessage("メールアドレスの形式に誤りがあります。");
          return;
        }

        setSentTo(email);
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  return (
    <div className={styles.wrap}>
      <div>
        <h1 className={styles.logo}>
          <Link className={styles.linkToTop} to="/" aria-label="TALTO">
            <IconLogo />
          </Link>
        </h1>
        <h2 className={styles.ttl}>パスワード再設定メールを送る</h2>
        {!sentTo ? (
          <form onSubmit={handleSubmit}>
            <label className={styles.label}>メールアドレス</label>
            <input
              className={styles.input}
              onChange={handleEmailChange}
              type="email"
              name="email"
              placeholder="メールアドレスを入力"
            />
            {errorMessage && (
              <p className={styles.errorMessage}>{errorMessage}</p>
            )}
            <div className={styles.submitAction}>
              <ProcessingButtonBase
                className={styles.buttonSubmit}
                labelProcessing="メールを送信"
                isProcessing={isProcessing}
                type="submit"
                disabled={email === ""}
              >
                メールを送信
              </ProcessingButtonBase>
            </div>
          </form>
        ) : (
          <p>
            <strong>{sentTo}</strong>{" "}
            にパスワード再設定メールを送信しました。しばらくしてもメールが届かない場合は、迷惑メールフォルダにないかご確認ください。
          </p>
        )}
        <p className={styles.login}>
          <Link to="/login">ログイン</Link>
          はこちら
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
